<template>
  <div>
    <div class="cv_list">
      <swiper :options="swiperOptionsVideoMsater">
        <swiper-slide v-for="(item, index) in videoList" :key="index">
          <div class="cvl_item">
            <div class="cvl_img">
              <a :href="'/old-page?id=' + item.id" target="_blank"
                ><img :src="item.src" alt=""
              /></a>
            </div>
            <div class="cvl_title">{{ item.name }}</div>
          </div>
        </swiper-slide>
      </swiper>
      <div
        class="swiper-button-next master-button-next el-icon-arrow-right"
        slot="pagination"
      ></div>
      <div
        class="swiper-button-prev master-button-prev el-icon-arrow-left"
        slot="pagination"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      swiperOptionsVideoMsater: {
        navigation: {
          nextEl: ".master-button-next",
          prevEl: ".master-button-prev",
        },
        slidesPerView: 7,
      },
      videoList: [
        {
          id: 19,
          src: "http://vphoto.kepuchina.cn/images/2020/1/3/2020131578033015730_76.jpg",
          name: "朱廷劭",
        },
        {
          id: 20,
          src: "http://vphoto.kepuchina.cn/images/2020/1/2/2020121577944805195_76.jpg",
          name: "赵公博",
        },
        {
          id: 21,
          src: "http://vphoto.kepuchina.cn/images/2019/12/31/201912311577772181696_76.jpg",
          name: "杨益民",
        },
        {
          id: 22,
          src: "http://vphoto.kepuchina.cn/images/2019/12/30/201912301577673367373_76.jpg",
          name: "邬晓钧",
        },
        {
          id: 23,
          src: "http://vphoto.kepuchina.cn/images/2019/12/26/201912261577328160098_76.jpg",
          name: "王传超",
        },
        {
          id: 24,
          src: "http://vphoto.kepuchina.cn/images/2019/12/25/201912251577243517270_76.jpg",
          name: "乔友林",
        },
        {
          id: 25,
          src: "http://vphoto.kepuchina.cn/images/2019/12/24/201912241577155009651_76.jpg",
          name: "毛利华",
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.cv_list {
  position: relative;
  .cvl_item {
    width: 160px;
    .cvl_img {
      width: 100%;
      height: 158px;
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
      }
    }
    .cvl_title {
      padding: 10px 0;
      @include fontSize(18px, 400, #353535, 25px);
      @include textoverflow;
    }
  }
  .swiper-container {
    position: relative;
    height: 100%;
  }
  .swiper-slide {
    margin-right: 4px;
  }
  .swiper-button-prev {
    top: 61px !important;
    left: 0 !important;
    width: 28px;
    height: 37px;
    margin-top: 0;
    background: #f4f4f4;
    border-radius: 0 100px 100px 0;
  }
  .swiper-button-next {
    top: 61px !important;
    right: 0 !important;
    width: 28px;
    height: 37px;
    margin-top: 0;
    background: #f4f4f4;
    border-radius: 100px 0 0 100px;
  }
  .swiper-button-prev::after {
    content: " ";
    //margin-left: -6px;
    //font-size: 18px;
    //font-weight: 600;
    //color: #979797;
  }

  .el-icon-arrow-left::before {
    margin-left: -6px;
    font-size: 24px;
    font-weight: 600;
    color: #979797;
  }

  .swiper-button-next::after {
    content: " ";
    //margin-left: 6px;
    //font-size: 18px;
    //font-weight: 600;
    //color: #979797;
  }
  .el-icon-arrow-right::before {
    margin-left: 6px;
    font-size: 24px;
    font-weight: 600;
    color: #979797;
  }
}
</style>
